import { useCallback } from 'react';

import { Editor } from '@tiptap/core';

export const useCardDelete = (
  editor: Editor,
  getPos: () => number | undefined,
  nodeSize: number,
) => {
  return useCallback(() => {
    const pos = getPos();
    if (typeof pos !== 'number') return;
    editor
      .chain()
      .focus()
      .deleteRange({ from: pos, to: pos + nodeSize })
      .run();
  }, [editor, getPos, nodeSize]);
};
